module.exports = __webpack_public_path__ + "static/media/notification.44dbd9e8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notification.mp3
// module id = 767
// module chunks = 0